import type { JobSummaryContentV2 } from '@xing-com/crate-common-graphql-types';
import type { NwtTrackingProps } from '@xing-com/crate-jobs-tracking';

import { JobsXingletWrapper } from '../../../jobs-xinglet';

import { AiJobSummarySkeleton } from './ai-job-summary-skeleton';

export type AiJobSummaryProps = {
  variant?: 'default' | 'card' | 'aside';
  summary?: JobSummaryContentV2;
  jobGlobalId: string;
  jobTitle?: string;
  companyName?: string;
  companyLogo?: string;
  isSuperMatch?: boolean;
  nwtTrackingProps?: Partial<NwtTrackingProps>;
};

export const AiJobSummary = JobsXingletWrapper<AiJobSummaryProps>(
  '@xing-com/crate-jobs-domain-job-details-ai-job-summary',
  <AiJobSummarySkeleton />
);
